<template>
  <div style="width: 100%">
    <loading v-show="showLoading"></loading>

    <div class="home_content" v-if="!showLoading">
      <!--首页搜索-->
      <div class="head_top">
        <div class="head_top_search" @click="popSearchView()"><img class="head_top_search_icon" src="@/images/icon_search.png"><span class="head_top_search_placeholder">hello kitty 公仔</span></div>
      </div>

      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">

        <!--精选好味-->
        <div class="gl_content clear_both" >
          <p class="gl_title">精选好味</p>
          <div class="pl_info1 fl" v-for="(productItem, productIndex) in productList" :key="productIndex">
            <router-link :to="{name:'goodsDetail',query:{goodsId:productItem.productId}}">
              <van-image class="pl_info1_img" fit="cover" :src="productItem.imageUrl"/>
            </router-link>
            <p class="pl_info1_title">{{productItem.productName}}</p>
            <span  class="pl_info1_price fl">¥{{productItem.price}}</span>
            <span class="pl_info1_addCart fr">{{productItem.quantity}}人付款</span>
          </div>
        </div>

        <!--分界线-->
        <div class="base_line"></div>

        <!--餐厅特价-->
        <div class="gl_content clear_both" >
          <p class="gl_title">餐厅特价</p>
          <div class="content_container">
            <div>
              <van-image class="full_w" style="height: 9.375rem" fit="cover" :src="require('@/images/goods_1.png')" />

            </div>
          </div>
        </div>
      </van-pull-refresh>

      <!--footer-->
      <footerView :cartInfo="{cartNum:catNum}"></footerView>
    </div>

    <div class="home_search" v-show="isShowSearch">
      <form action="/">
        <van-search
          class="search_br"
          shape="round"
          placeholder="自助餐"
          show-action
          @search="searchAction()"
          v-model="searchValue"
          @cancel="dismissSearchView"
        />
      </form>
      <div class="content_container" >
        <p class="zt12">热门搜索</p>
        <ul class="tag_list" >
          <li class="fl" v-for="(tagItem, index) in tagList" :key="index"><router-link :to="{path:'/productList', query:{keyWord:tagItem.keyword}}"><span class="tag_item zt12">{{tagItem.keyword}}</span></router-link></li>
          <transition name="router-slid" mode="out-in">
            <router-view></router-view>
          </transition>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId,loginInfo,productRecommend, } from '@/router/Constant'
  import { login,getShoppingHomeBanner,getProductCategory,getKeyword,getActivities,getProductRecommend,getProductInfo,addProductToCart,getShoppingCartNum,getProductAttributes } from '@/router/api';
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';
  import { NavBar,Swipe,SwipeItem,Image,Grid,Tabbar,Toast,Search,PullRefresh,Dialog } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue'

  export default {
    name: 'foodHome',
    data () {
      return {
        token:"",
        searchValue:"",
        showLoading:true,
        isShowSearch:false,
        bannerList:[],
        advList:[],
        productCatagoryList:[],
        productList:[],
        tagList:[],
        count: 0,
        isLoading: false,
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        catNum:0,
      }
    },
    methods: {
      async initData() {
        this.checcheckLoginStatus();
        this.getShoppingHomeBanner();
        this.getProductCategory();
        this.getActivities();
        this.getProductRecommend();
        this.getKeyword();
        this.getShoppingCartNum();
      },
      // checkLoginStatus
      checcheckLoginStatus(){
        if (getStore('externalLoginKey')==undefined || getStore('externalLoginKey')== "") {
          setStore('islogIn',false)
          if (getCookie('authorization')==undefined || getCookie('authorization')== "") {
            Toast("会员系统未登录,请先登录会员系统")
          } else {
            this.token = "Bearer " + getCookie('authorization');
            this.login();
            this.getShoppingCartNum();
          }
        } else {
          console.log('用户当前是登录状态' + getStore('externalLoginKey'))
        }
      },
      login (){
        login({token:"Bearer "+getCookie('authorization')})
          .then(res => {
            console.log("login")
            console.log(res)
            if (res._TOKEN_){
              setStore('externalLoginKey',res._TOKEN_)
              setStore('islogIn',true)
            } else {
              Toast(res._ERROR_MESSAGE_)
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      // 弹出搜索框
      popSearchView: function () {
        this.isShowSearch = true;
        document.querySelector('body').setAttribute('style', 'overflow:hidden');
      },
      // 隐藏框搜索框
      dismissSearchView: function () {
        this.isShowSearch = false;
        document.querySelector('body').removeAttribute('style');
      },
      //下拉刷新
      onRefresh() {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      },
      getShoppingHomeBanner (){
        getShoppingHomeBanner({token:this.token,productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId})
          .then(res => {
            console.log("getShoppingHomeBanner")
            console.log(res)
            this.bannerList = res.bannerList
          })
          .catch(err => {
            console.log(err);
          });
      },
      getProductCategory () {
        getProductCategory({token:this.token,productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId})
          .then(res => {
            console.log("getProductCategory")
            console.log(res)
            if (res.productCategoryList) {
              if (res.productCategoryList) {
                for (let i = 0;i<res.productCategoryList.length;i++){
                  if (i<7) { // 取前8个
                    res.productCategoryList[i]['toPlace'] = "/productList?productCategoryId=" + res.productCategoryList[i].productCategoryId;
                    this.productCatagoryList.push(res.productCategoryList[i])
                  }
                }
              }
              //push更多
              let productItem = {
                "productCategoryId": "～",
                "categoryName": "更多",
                "categoryImageUrl": require("@/images/icon_8.png"),
                "toPlace":'/classify'
              }
              this.productCatagoryList.push(productItem);
              this.showLoading = false
            } else {
              this.showLoading = false
              Toast(res._ERROR_MESSAGE_);
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getActivities () {
        getActivities({token:this.token,productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId})
          .then(res => {
            console.log('getActivities');
            console.log(res);
            this.advList = res.bannerList;
          })
          .catch(err => {
            console.log(err);
          });
      },
      getProductRecommend() {
        getProductRecommend({token:this.token,productStoreId:this.productStoreId,productCategoryId:productRecommend,prodCatalogId:this.prodCatalogId})
          .then(res => {
            this.productList = res.productList
            console.log(res)
            console.log('getProductRecommend');
          })
          .catch(err => {
            console.log(err);
          });
      },
      getKeyword(){
        getKeyword({token:this.token,productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId})
          .then(res => {
            console.log(res)
            console.log('getKeyword');
            this.tagList = res.kryWordList
          })
          .catch(err => {
            console.log(err);
          });
      },
      addCart(productId) {
        if (getStore('islogIn') == 'false') {
          this.dialogAction('需要登录会员系统，是否去登录？')
        } else {
          addProductToCart({externalLoginKey:getStore('externalLoginKey'),quantity:1,productId:productId,productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId})
            .then(res => {
              console.log(res)
              if (res._ERROR_MESSAGE_) {
                Toast(res._ERROR_MESSAGE_);
              } else {
                Toast(res._EVENT_MESSAGE_);
                this.getShoppingCartNum();
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      },
      getShoppingCartNum(){
        getShoppingCartNum({externalLoginKey:getStore('externalLoginKey'),productStoreId:this.productStoreId})
          .then(res => {
            console.log('getShoppingCartNum');
            console.log(res)
            this.catNum = res.catNum;
          })
          .catch(err => {
            console.log(err);
          });
      },
      dialogAction(msg){
        Dialog.confirm({
          message: msg
        }).then(() => {
          if (getStore('fromType')=='mini') {
            wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          } else {
            wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          }
        }).catch(() => {

        });
      },
      searchAction(){
        this.$router.push({path:'/productList',query:{keyWord:this.searchValue}})
      },
      pushWebUrl(url) {
        if (url){
          window.location.href = url;
        } else {
          Toast("请设置正确跳转链接");
        }
      },
    },
    components: {
      [NavBar.name]: NavBar,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Image.name]: Image,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      [Search.name]: Search,
      [PullRefresh.name]: PullRefresh,
      [Dialog.name]: Dialog,
      footerView,
      loading,
    },
    mounted() {
      this.initData();
    },
    beforeDestroy(){
      this.isShowSearch = false;
      document.querySelector('body').removeAttribute('style')
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .home_content {
    padding-top: 3rem;
  }

  .home_search {
    width: 100%;height: 100%;position: fixed;top: 0;background-color: white;z-index: 99;
  }

  .head_top {
    background-color: white;padding-top: 0.5rem;padding-bottom: 0.5rem;position: fixed;top: 0;left: 0;width: 100%;z-index: 99
  }

  .head_top_search {
    width: 20rem;margin-left: 0.85rem;background-color: #f5f5f5;height: 2rem;line-height: 2rem;padding: 0 0.8rem;border-radius: 1rem
  }

  .head_top_search_icon {
    width: 0.8rem;height: 0.8rem;margin-right: 0.5rem
  }

  .head_top_search_placeholder {
    font-size: 0.75rem;color: #999999
  }

  .content_container {
    padding: 0 1rem
  }

  .banner_item {
    width: 21.5rem;
    height: 10rem;
  }

  .banner_br {
    padding-bottom: 1rem;
  }

  .base_line {
    height: 0.6rem;
    background-color: #f4f4f4;
  }

  .adv_height {
    height: 5rem;
  }

  .classify_item {
    float: left;
    width: 3.3rem;
    height: 5rem;
    padding: 0.5rem 1rem;
  }

  .classify_adv_content {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .classify_adv_content > div:nth-child(1) {
    width:8.75rem;
    height: 11.25rem;
    margin-right: 0.6rem;
  }

  .classify_adv_content > div:nth-child(1) > a  > div {
    width:8.75rem;
    height: 11.25rem;
  }

  .classify_adv_content > a > div:nth-child(2) {
    width:12rem;
    height: 11.25rem;
  }

  .classify_adv_content > div:nth-child(2) > a  > div:nth-child(1) {
    width: 12rem;height: 5rem;margin-bottom: 1rem
  }

  .classify_adv_content a > div:nth-child(2) > a > div:nth-child(2) {
    width: 12rem;height: 5rem;
  }

  .gl_content {
    padding-bottom: 3rem;
  }

  .gl_border {
    border-radius: 0.5rem 0.5rem 0 0;
    width: 10.25rem;height: 10.25rem;
  }

  .gl_title {
    padding-left: 1rem;font-weight: bold;border-left-width: 0.1rem;border-left-style: solid;border-left-color: #EB84AB
  }

  .pl_info1 {
    width: 11.68rem;height: 15.625rem;padding: 0.5rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info1_img {
    width: 10rem;
    height: 8.75rem;
  }

  .pl_info1:nth-child(odd) {
    border-right: 1px solid #eaeaea;
  }

  .pl_info1_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.75rem;color: #333333;margin-bottom: 0.5rem;
  }

  .pl_info1_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info1_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
  }

  .tag_list > li {
    line-height: 2rem;
    margin: 0 0.6rem 0.6rem 0;
  }

  .tag_item {
    background-color: #f5f5f5;padding: 0.5rem 1rem;border-radius: 0.3rem;
  }

  .router-slid-enter-active, .router-slid-leave-active {
    transition: all .4s;
  }
  .router-slid-enter, .router-slid-leave-active {
    transform: translate3d(2rem, 0, 0);
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/tastyFoods/foodHome.vue